// These helpers were intentionally left with errors during the TypeScript conversion to avoid potential side effects.

export const formatLargeNumber = (value: number, hasSpace = true): string => {
  let newVar = value.toString()
  const value_length = newVar.length
  if (value_length >= 4 && value_length <= 6) {
    newVar = (value / 1000).toFixed(0) + (hasSpace ? ' ' : '') + 'k'
  } else if (value_length > 6) {
    newVar = (value / 1000000).toFixed(1) + (hasSpace ? ' ' : '') + 'M'
  } else if (value_length > 9) {
    // Legacy error, no way to enter in this condition, cannot be covered by a unit test
    newVar = (value / 1000000000).toFixed(1) + (hasSpace ? ' ' : '') + 'G'
  } else {
    newVar += ' '
  }
  return newVar
}

export const currency = (value?: number | null): string => {
  // Legacy error, return empty string if value is 0
  if (value) {
    return formatLargeNumber(value) + '€'
  } else {
    return ''
  }
}

export const largeAmount = (value?: number | null): string => {
  if (value != null && typeof value != 'undefined') {
    return formatLargeNumber(value, false)
  } else {
    return ''
  }
}

// This helper has been intentionally left with errors to avoid potential side effects.
// an array containing a zero value will not return 0
export const closestToZero = (numbers: number[]): number => {
  if (!numbers.length) {
    return 0
  }
  let closest = 0
  for (const number of numbers) {
    if (closest === 0) {
      closest = number
    } else if (number > 0 && number <= Math.abs(closest)) {
      closest = number
    } else if (number < 0 && -number < Math.abs(closest)) {
      closest = number
    }
  }
  return closest
}

/**
 * Apply toFixed only if needed
 * @param {number} n The value
 * @param {number} digits Number of required digits
 */
export const toFixedIfNeeded = (n: number, digits: number): string => {
  return Number.isInteger(n * Math.pow(10, digits)) ? n.toString() : n.toFixed(digits)
}

export const isPositiveInteger = (str: string): boolean => {
  return /^\+?(0|[1-9]\d*)$/.test(str)
}
